import React, { useContext, useEffect, useState } from "react";
import { AddOutlined } from "@mui/icons-material";
import { Autocomplete, TextField, Stack, Button, CircularProgress, Container, Modal, FormControl, InputLabel, MenuItem, Select } from "@mui/material";

import config from "../../hoa-config";
import { GlobalContext } from "../../context/hoa-global-context";
import dashboardServices from "../../services/hoa-dashboard-api-service";

export default function WebhookAddComponent(props: any) {

    const { title, subTitle, tagType, open, setOpen, loading, setLoading, selectedValues, updateSelectedValues, activeTab, onStatusFilterChange } = props;

    const [state, setState] = useState<any>({});

    useEffect(() => {
        if(selectedValues){
            setState(selectedValues);
        }
    },[selectedValues])

    const handleModalOpen = () => {
        setOpen(true);
    }

    const onClose = () => {
        setOpen(!open);
        updateSelectedValues({});
        setState({});
    }

    return (
        <>
            <main style={{
                backgroundColor: "white",
                height: "102px",
                borderTop: "1px solid #e8e8e8",
                borderLeft: "1px solid #e8e8e8",
                borderRight: "1px solid #e8e8e8",
                borderBottom: "1px solid #e8e8e8",
                borderRadius: "4px 4px 0px 0px",
            }}>
                <div className="filtering-sub-container">
                    <div className="filtering-container left">
                        <span className="filtering-left-container-title">{title}</span>
                        <span className="filtering-left-container-subtitle">{subTitle}</span>
                    </div>
                    {activeTab == 0 ?
                        <div className="filtering-container right">
                            <Button
                                onClick={handleModalOpen}
                                startIcon={<AddOutlined />}
                                style={{ background: '#3576E5', color: 'white', width: '139px', height: '48px', borderRadius: '4px', textTransform: 'capitalize' }}
                                variant="contained">
                                <span className="add-new-btn">Add New</span>
                            </Button>
                        </div>
                        :
                        <FormControl>
                            <InputLabel id="demo-simple-select-helper-label">Status</InputLabel>
                            <Select
                                style={{ width: '139px', height: '51px', borderRadius: '4px' }}
                                labelId="demo-simple-select-helper-label"
                                id="demo-simple-select-helper"
                                name={'status'}
                                label="Status"
                                onChange={onStatusFilterChange}
                            >
                                <MenuItem value="all">All</MenuItem>
                                <MenuItem value="success"><span style={{ height: 15, width: 15, marginRight: 5, borderRadius: 8, backgroundColor: "#E8F5EC" }}></span> Success</MenuItem>
                                <MenuItem value="failed"><span style={{ height: 15, width: 15, marginRight: 5, borderRadius: 8, backgroundColor: "#FFECB3" }}></span> Failed</MenuItem>
                            </Select>
                        </FormControl>
                    }
                </div>
            </main>
            <AddModal open={open} onClose={onClose} state={state} setState={setState} loading={loading} setLoading={setLoading} />
        </>
    )
}

const AddModal = ({ open, onClose, state, setState, loading, setLoading }: any) => {
    const { triggerNotifications, updateTriggerNotificationData } = useContext<any>(GlobalContext)
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState('');
    const [checkError, setCheckError] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [organizations, setOrganizations] = useState<any>([]);

    const onEnter = async (event: any) => {
      if (event.key === "Enter") {
        setIsLoading(true);
        const organizations = await dashboardServices.getHoaEnabledOrganization(event.target.value);
        if(organizations){
          setOrganizations(organizations.data);
          setIsLoading(false);
        }
      }
    }

    const onSelectOrgId = (value: any) => {
        if(!value) return;
        setState({ ...state, organizationId: value.id })
      }

    const handleChange = (value: string, key: string) => {
        setState({ ...state, [key]: value })
    }

    const saveWebhook = async () => {
        setCheckError(true);
        setLoading(true);
        if(state.objectId && state.organizationId && state.type && state.event && state.url){
            onClose();
            const updatedResult = await dashboardServices.updateWebhookUrl(state);

            let updateIndex = 0;
            triggerNotifications.data.find((value: any, index: number) => {
                if(value.objectId === state.objectId){
                    updateIndex = index;
                }
            });
    
            triggerNotifications.data[updateIndex] = updatedResult.data;
            updateTriggerNotificationData({...triggerNotifications})
            
            setState({});
            setSuccess(true);
            setCheckError(false);
            setMessage(`Webhook updated successfully.`);
        }
        if (!state.objectId && state.organizationId && state.type && state.event && state.url) {
            onClose();
            const res = await dashboardServices.addWebhookUrl(state);
            if (res.status == 200) {
                let allData = JSON.parse(JSON.stringify(triggerNotifications.data));
                allData.unshift(res.data);
                let updatedData = {
                    ...triggerNotifications,
                    fetchingFilteredData:true,
                    data: allData,
                }
                updateTriggerNotificationData(updatedData)
                setState({});
                setSuccess(true);
                setMessage(`Webhook added successfully.`);
            } else {
                setSuccess(true);
                setMessage(`Something went wrong!`);
            }
            setCheckError(false);
        }
        setLoading(false)
    }
    return (
        <Modal open={open} onClose={onClose}>
            <Container
                style={{
                    background: "white",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "548px",
                    maxHeight: "645px",
                    overflow: "auto",
                    borderRadius: "8px 8px 0px 0px",
                    padding: "0px",
                }}
            >
                <div style={{ background: "#EFF4FC" }}>
                    <div className="modal-title-container">
                        <span className="text-3E3E3E-20px bold">Add Webhook</span>
                        <span className="text-5B5B5B-14px  normal">
                            Please give the necessary information.
                        </span>
                    </div>
                </div>
                <div className="modal-wrapper-doc">
                    {
                        state.objectId && (
                            <div style={{ marginTop: "8px" }}>
                                <TextField
                                    style={{
                                        width: "462px",
                                        margin: "2px",
                                        padding: "10px 0px",
                                    }}
                                    aria-readonly
                                    variant="standard"
                                    name="organizationId"
                                    value={state.organizationId || ""}
                                    label="Organization"
                                />
                            </div>
                        )
                    }
                    {
                        !state.objectId && (
                            <div style={{ marginTop: "8px" }}>
                            <Autocomplete
                                id="asynchronous-demo"
                                sx={{ width: 300 }}
                                open={isOpen}
                                onOpen={() => {
                                    setIsOpen(true);
                                }}
                                onClose={() => {
                                    setIsOpen(false);
                                }}
                                onKeyDown={onEnter}
                                onChange={(option:any, value:any) => onSelectOrgId(value)}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                getOptionLabel={(option) => option.name}
                                options={organizations}
                                loading={isLoading}
                                renderInput={(params: any) => (
                                    <TextField
                                    {...params}
                                    error={checkError && !state.organizationId}
                                    label="Organization"
                                    style={{width: "462px",}}
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                        <React.Fragment>
                                            {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </React.Fragment>
                                        ),
                                    }}
                                    />
                                )}
                                />
                            </div>
                        )
                    }
                    <div style={{ marginTop: "8px" }}>
                    <Autocomplete
                        ListboxProps={{ style: { maxHeight: "200px"} }}
                        style={{ width: "462px", height:"62px", boxSizing:"border-box"}}
                        disablePortal
                        value={state.type ? state.type : ''}
                        options={config.tagTypes}
                        onChange={(e, v) => {
                            handleChange(v, 'type')
                        }}
                        renderInput={(params: any) => <TextField error={checkError && !state.type} variant="standard" required style={{height:"100%"}} {...{...params, InputProps:{...params.InputProps, style:{height:"100%"}}}} label="Type"/>}
                    />
                    </div>
                    <div style={{ marginTop: "8px" }}>
                        <Autocomplete
                            ListboxProps={{ style: { maxHeight: "200px"} }}
                            style={{ width: "462px", height:"62px", boxSizing:"border-box"}}
                            disablePortal
                            value={state.event ? state.event : ''}
                            options={state.type === 'Hoa' ? config.hoaEvents : state.type === 'Municipality' ? config.municipalityEvents : state.type === 'Property' ? config.propertyEvents : []}
                            onChange={(e, v) => {
                                handleChange(v, 'event')
                            }}
                            renderInput={(params: any) => <TextField variant="standard" required error = {checkError && !state.event} style={{height:"100%"}} {...{...params, InputProps:{...params.InputProps, style:{height:"100%"}}}} label="Event"/>}
                        />
                    </div>
                    <div style={{ marginTop: "8px" }}>
                        <TextField
                            style={{
                                width: "462px",
                                margin: "2px",
                                padding: "10px 0px",
                            }}
                            required
                            variant="standard"
                            name="url"
                            value={state.url || ""}
                            onChange={(e) => {
                                handleChange(e.target.value, 'url')
                            }}
                            label="Webhook URL"
                            error={checkError && !state.url}
                        />
                    </div>
                    <Stack
                        style={{ marginTop: "24px" }}
                        direction={"row"}
                        spacing={1}
                        justifyContent="flex-end"
                    >
                        <Button onClick={() => onClose()} variant="outlined">
                            No
                        </Button>
                        <Button onClick={saveWebhook} variant="contained">
                            Yes
                        </Button>
                    </Stack>
                </div>
            </Container>
        </Modal >
    );
}